import { useTranslation } from 'next-i18next';
import { UserMatch } from '../../../../../../interfaces/interfaces';
import { useSelector } from '../../../../../../reduxToolkit/typedRedux';

export interface WaitingForDisplayProps {
  match: UserMatch | undefined;
}

export const WaitingForDisplay = (props: WaitingForDisplayProps) => {
  const { match } = props;

  const { t } = useTranslation();

  const registration = useSelector(({ common }) => common.eventRegistration);

  return (
    <div className="absolute h-full w-full flex justify-end">
      <div className="w-1/2 h-full bg-black flex justify-center items-center">
        <p className="animate-pulse" style={{ color: 'white' }}>
          {t('matching:waiting-for', {
            name:
              match?.participantA.registration._id === registration?._id
                ? match?.participantB.registration.user?.name
                : match?.participantA.registration.user?.name,
          })}
        </p>
      </div>
    </div>
  );
};
